import { MAXPAYOUT_DATA, MAXPAYOUT_ERROR, MAXPAYOUT_HIDE_ERROR, } from "../interface/iMaxPayout";
const initialState = {
    data: {},
    errorData: { error: null, isOpen: false },
};
const maxPayoutReducer = (state = initialState, action) => {
    switch (action.type) {
        case MAXPAYOUT_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case MAXPAYOUT_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case MAXPAYOUT_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        default:
            return Object.assign({}, state);
    }
};
export default maxPayoutReducer;
